import React from "react";
import Skills from "../skills/Skills";

const AboutDark = () => {
  return (
    <>
      <div className="about_inner">
        <div className="left">
          <img src="img/thumbs/1-1.jpg" alt="" />
          <div
            className="image"
            data-aos="fade-right"
            data-aos-duration="1200"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/about/avatar-no-bg.png"
              })`,
              border: "1px solid #555",
            }}
          ></div>
        </div>
        <div
          className="right"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="50"
        >
          <div className="short">
            <h3>I'm Ahmmed Abir</h3>
            <h5>
              A Software Engineer,{" "}
              <span className="theme-color">
                Programmer &amp; Problem Solver
              </span>{" "}
              based in <span className="theme-color">Bangladesh</span>
            </h5>
            <p>
              I am an enthusiastic programmer and dedicated software developer
              with a fervent passion for unraveling logical challenges and
              embracing emerging technologies. My expertise lies in crafting
              dynamic web and mobile applications, predominantly harnessed
              through JavaScript and TypeScript. I have a profound affection for
              TypeScript, as it enables me to bring my innovative ideas to life.
              My ultimate goal is to contribute to expanding online
              accessibility and openness, making the internet a more inclusive
              space for everyone.
            </p>
          </div>
          <div className="extra">
            <h3 className="title">Personal Info</h3>
            <div className="list">
              <ul>
                <li>
                  <p>
                    <span>Name :</span> Abu Musa Ahmed Abir
                  </p>
                </li>
                <li>
                  <p>
                    <span>Phone :</span> +8801727567755
                  </p>
                </li>
                <li>
                  <p>
                    <span>Nationality :</span> Bangladeshi
                  </p>
                </li>
                <li>
                  <p>
                    <span>Email :</span> ahmmedabir9@gmail.com
                  </p>
                </li>
                <li>
                  <p>
                    <span>Blood Group :</span> B+
                  </p>
                </li>
                <li>
                  <p>
                    <span>Languages :</span> Bangla, English
                  </p>
                </li>
              </ul>
            </div>
            <div className="beny_tm_button color-outline">
              <a
                href="https://drive.google.com/file/d/1yWQQkDdPIU2fP6PwelHC8MYggqtXVW2u/view?usp=drive_link"
                download
                target="_blank"
              >
                <span className="wrapper">
                  <span className="first">Download Resume</span>
                  <span className="second">Download Resume</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Skills />
    </>
  );
};

export default AboutDark;
